import { useEffect } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { generateUniqueId } from "Utils/UniqueId";

const uuid = generateUniqueId(true);

export function useGlobalStyles() {
  const { semanticColors } = useTheme();
  useEffect(() => {
    const scrollbars = `
      ::-webkit-scrollbar-track-piece {
        -webkit-border-radius: 0;
        background-color: ${semanticColors.bodyFrameBackground};
      }

      ::-webkit-scrollbar {
        height: 8px;
        width: 8px;
      }

      ::-webkit-scrollbar-thumb {
        -webkit-border-radius: 4px;
        background-color: ${semanticColors.primaryButtonTextDisabled};
        border: 2px solid ${semanticColors.primaryButtonTextDisabled};
        height: 50px;
        outline-offset: -2px;
        outline: 2px solid ${semanticColors.primaryButtonTextDisabled};
      }

      ::-webkit-scrollbar-thumb:hover {
        -webkit-border-radius: 4px;
        background-color: ${semanticColors.inputPlaceholderBackgroundChecked};
        border: 2px solid ${semanticColors.inputPlaceholderBackgroundChecked};
        height: 50px;
        outline: 2px solid ${semanticColors.inputPlaceholderBackgroundChecked};
      }

      ::-webkit-scrollbar-corner {
        background-color: ${semanticColors.bodyFrameBackground};
      }
    `.trim();

    removeGlobalStyles();
    addGlobalStyles(scrollbars);
  }, [semanticColors]);
}

function addGlobalStyles(rule: string) {
  const style = document.createElement(`style`);
  style.id = uuid;
  style.appendChild(document.createTextNode(rule));
  document.head.appendChild(style);
}

function removeGlobalStyles() {
  const style = document.getElementById(uuid);
  if (style == null) {
    return;
  }

  style.remove();
}
